if (!customElements.get('product-card-carousel')) {
  customElements.define(
    'product-card-carousel',
    class ProductCardCarousel extends window.BAO.CustomElement() {
      connectedCallback () {
        if (!this.els.carousel || !this.els.slide) {
          console.error('Carousel or slide elements not found')
          return
        }

        this.initalizeCarousel()
      }

      initalizeCarousel () {
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.els.slide.elements.forEach(slide => {
            slide.classList.add('clc-Items_Items-animate')

            slide.addEventListener('animationstart', () => {
              slide.style.overflow = 'visible'
            })
            slide.addEventListener('animationend', () => {
              slide.style.overflow = 'hidden'
            })
          })
        }
      }
    },
  )
}
